/**
 * EnergyConnect.WebApi | v1
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export const ConnectionType = {
    NotSpecified: 'NotSpecified',
    DirectConnected: 'DirectConnected',
    InstallationConnected: 'InstallationConnected',
} as const;
export type ConnectionType = typeof ConnectionType[keyof typeof ConnectionType];

